import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTopLevelOpen } from "../Actions/Navigation.action";
import { setCategoryTabOpen, setFilterTabOpen } from "../Actions/FacetedSearch.action";
import { toggleShowSearchResult } from "../Actions/QuickSearch.action";
const SiteOverlay = () => {
    const dispatch = useDispatch();
    const state = useSelector(state => state.navigation);
    const { showResult } = useSelector((state) => state.quickSearch);
    const { filterTabOpen, categoryTabOpen } = useSelector((state) => state.facetedSearch);
    const { topLevelOpen } = state;
    let showOverlay = showResult || topLevelOpen || filterTabOpen || categoryTabOpen;
    let mainClass = 'overlay';
    mainClass += (showOverlay ? ` ${mainClass}--visible` : '');
    const close = () => {
        if (showResult) {
            dispatch(toggleShowSearchResult());
        }
        if (filterTabOpen) {
            dispatch(setFilterTabOpen(false));
        }
        if (categoryTabOpen) {
            dispatch(setCategoryTabOpen(false));
        }
        dispatch(setTopLevelOpen(false));
    };
    return (_jsx("div", { className: mainClass, onTouchStart: close, onClick: close }));
};
export default SiteOverlay;
